import React, { useEffect, useState, useRef } from 'react';
import auth from '../../services/auth';
import { extractRequestParams } from './util';
import { WithTranslation } from 'react-i18next';
import Link from '@rezdy/components/Link';
import TextStyle from '@rezdy/components/TextStyle';

export function useTimeout(
    callback: React.EffectCallback,
    delay: number | null
): React.MutableRefObject<number | null> {
    const timeoutRef = useRef<number | null>(null);
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        if (typeof delay === 'number') {
            timeoutRef.current = window.setTimeout(() => callbackRef.current(), delay);

            return () => window.clearTimeout(timeoutRef.current || 0);
        }
    }, [delay]);

    return timeoutRef;
}
export function ResendConfirmationCode({ i18n, t, tReady }: WithTranslation) {
    const { newEmail } = extractRequestParams();
    const [error, setError] = useState('');
    const [processing, setProcessing] = useState(false);
    const [, setProcessed] = useState<boolean>(false);

    const translationProps = { i18n, t, tReady };

    const requestEmailChange = async () => {
        if (!newEmail) {
            setError('Missing newEmail parameter');
            return;
        }
        try {
            setProcessing(true);
            await auth.requestEmailChange({ newEmail });
            setProcessed(true);
        } catch (e) {
            setError((e as Error).message);
        }
    };

    useTimeout(() => setProcessing(false), processing ? null : 59 + 4 * 60);

    return (
        <>
            {errorMessage(error, processing)}
            <TextStyle as="p" style={{ textDecoration: 'underline', marginTop: '30px' }}>
                <Link onClick={requestEmailChange}>
                    <strong>Resend Confirmation Email</strong>
                </Link>
            </TextStyle>
        </>
    );
}

const errorMessage = (error: string, processing: boolean) => {
    if (error) {
        return <p style={{ color: 'red', marginTop: '50px' }}>{'An error happened, please retry'}</p>;
    }
    if (processing) {
        return (
            <p style={{ color: 'blue', marginTop: '50px' }}>
                {'A request has been sent, please try again in a few mins'}
            </p>
        );
    }
    return null;
};
